import { PictureOutlined } from '@ant-design/icons';

import './NoPicture.scss';

export const NoPicture = () => {
  return (
    <div className="no-picture">
      <PictureOutlined className="icon" />
    </div>
  );
};
